import { STATUS } from "@/utils/constants";

import { RESET, SET_IS_CREATING_TEMPLATE_STATUS } from "./select-template.actionTypes";

const initialState = {
  isCreatingTemplateStatus: STATUS.IDLE,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_CREATING_TEMPLATE_STATUS: {
      return {
        ...state,
        isCreatingTemplateStatus: action.payload,
      };
    }

    case RESET: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};
